import ConfirmationDialog from "../ConfirmationDialog";
import React from "react";

export const CloseProjectDialog = ({...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { props.onClose }
        cancelButton={{
            action: props.onClose,
            label: 'No, Cancel'
        }}
        acceptButton={{
            action: props.onAccept,
            label: 'Yes, Close Project'
        }}
        header="Do you want to Close this project?"
    />;

export default CloseProjectDialog;
